import React, { Component } from "react";
import FullCalendar from "@fullcalendar/react";
import dayGridPlugin from "@fullcalendar/daygrid";
import timeGridPlugin from "@fullcalendar/timegrid";
import interactionPlugin from "@fullcalendar/interaction";
import "../../../../../src/main.scss";
import moment from "moment";
import _ from "lodash";
import DotLoader from "react-spinners/DotLoader";
import { css } from "@emotion/core";
 import ModalAjoutMenus from "./ModalAjoutMenus";
import ModalUpdateDeleteMenus from "./ModalUpdateDeleteMenus";
import {
  getMenusRepas,
  addMenusRepas,
  editMenusRepas,
  deleteMenusRepas,
} from "../menus/Menus.ducks";
import { connect } from "react-redux";
import { Link } from "react-router-dom";

const override = css`
  display: block;
  margin: 0 auto;
  border-color: red;
`;

class Menus extends Component {
  calendarComponentRef = React.createRef();
  constructor(props) {
    super(props);
    this.state = {
      calendarWeekends: true,
      calendarEvents: [],
      isOpenAjout: false,
      isOpenDeleteUpdate: false,
      textMenuPetits: "",
      textMenuGrands: "",
      dateStartMonth: "",
      dateEndMonth: "",
      activeStart: "",
      activeEnd: "",
      eventEdit: {},
      activeMonth: moment().month(8),
      activeYear: moment().year(),
    };
    this.openModalAjoutRepas = this.openModalAjoutRepas.bind(this);
    this.closeModalAjoutRepas = this.closeModalAjoutRepas.bind(this);
    this.closeModalUpdateDeletetRepas = this.closeModalUpdateDeletetRepas.bind(
      this
    );
    this.myChangeHandlerPetits = this.myChangeHandlerPetits.bind(this);
    this.myChangeHandlerGrands = this.myChangeHandlerGrands.bind(this);
    this.handleSubmitRepas = this.handleSubmitRepas.bind(this);
    this.handleModifieRepas = this.handleModifieRepas.bind(this);
    this.callbackFunction = this.callbackFunction.bind(this);
    this.windowClick = this.windowClick.bind(this);
    this.handleDateClick = this.handleDateClick.bind(this);
    this.handleEventClick = this.handleEventClick.bind(this);
    this.handleRepasDelete = this.handleRepasDelete.bind(this);
  }

  componentWillUnmount() {
    window.removeEventListener("click", this.windowClick, false);
  }
  componentDidMount() {
    if (window) {
      window.addEventListener("click", this.windowClick, false);
    }
  }
  componentDidUpdate(prevProps) {
    if (prevProps.dataRepas !== this.props.dataRepas) {
      this.setState({ calendarEvents: this.props.dataRepas });
    }
  }
  getMonthDateRange(date) {
    var startDate = moment(date);
    var endDate = moment(startDate).endOf('month');
    return { start: startDate.format("yyyy-MM-DD"), end: endDate.format("yyyy-MM-DD") };
  }
  windowClick(event) {
    if (
      event.target.classList.contains("fc-icon-chevron-left") ||
      event.target.classList.contains("fc-prev-button")
    ) {
      let activeStart = moment(this.state.activeStart).format("yyyy-MM-DD");
      let month = moment(activeStart);
      month.month();
      month.format("yyyy-MM-DD");
      let nextMonth = moment(activeStart)
        .subtract(1, "M")
        .format("yyyy-MM-DD");
      let endOfMonth = moment(nextMonth)
        .endOf("month")
        .format("YYYY-MM-DD");
      let days = moment(nextMonth).day();
      let startRange = Object.assign({}, moment(nextMonth).subtract(days, "d"));
      let addedDays = 12 - days;
      let endRange = Object.assign({}, moment(endOfMonth).add(addedDays, "d"));
      this.setState({
        activeStart: moment(nextMonth).format("yyyy-MM-DD"),
        activeEnd: moment(nextMonth).format("yyyy-MM-DD"),
        startRange: moment(startRange).format("yyyy-MM-DD"),
        endRange: moment(endRange).format("yyyy-MM-DD"),
      });
      this.props.getMenusRepas(
        localStorage.getItem("token"),
        moment(startRange).format("yyyy-MM-DD"),
        moment(endRange).format("yyyy-MM-DD")
      );
    } else if (
      event.target.classList.contains("fc-icon-chevron-right") ||
      event.target.classList.contains("fc-next-button")
    ) {
      let activeStart = moment(this.state.activeStart).format("yyyy-MM-DD");
      let month = moment(activeStart);
      month.month();
      month.format("yyyy-MM-DD");

      let nextMonth = moment(activeStart)
        .add(1, "M")
        .format("yyyy-MM-DD");

      let endOfMonth = moment(nextMonth)
        .endOf("month")
        .format("YYYY-MM-DD");

      let days = moment(nextMonth).day();
      let startRange = Object.assign({}, moment(nextMonth).subtract(days, "d"));

      let addedDays = 12 - days;

      let endRange = Object.assign({}, moment(endOfMonth).add(addedDays, "d"));

      this.setState({
        activeStart: moment(nextMonth).format("yyyy-MM-DD"),
        activeEnd: moment(nextMonth).format("yyyy-MM-DD"),
        startRange: moment(startRange).format("yyyy-MM-DD"),
        endRange: moment(endRange).format("yyyy-MM-DD"),
      });
      this.props.getMenusRepas(
        localStorage.getItem("token"),
        moment(startRange).format("yyyy-MM-DD"),
        moment(endRange).format("yyyy-MM-DD")
      );
    }
  }
  callbackFunction(info) {
    let start = moment(info.view.props.dateProfile.currentRange.start).format(
      "yyyy-MM-DD"
    );
    let end = moment(info.view.props.dateProfile.currentRange.end).format(
      "yyyy-MM-DD"
    );
    this.props.getMenusRepas(localStorage.getItem("token"), start, end);

    this.setState({
      activeStart: moment(start).format("yyyy-MM-DD"),
      activeEnd: moment(end).format("yyyy-MM-DD"),
    });
  }

  handleClick() {
    this.setState({ isOpenDeleteUpdate: true });
  }
  handleDateClick = (arg) => {
    if (!_.isEmpty(this.state.calendarEvents)) {
      let result = {};
      this.state.calendarEvents.forEach((element) => {
        if (arg.dateStr === moment(element.start).format("yyyy-MM-DD")) {
          result = Object.assign({}, element, result, {
            [element.title]: element.description,
          });
        }
      });
      if (_.isEmpty(result)) {
        this.setState({
          isOpenAjout: true,
          arg: arg,
        });
      } else {
        this.setState({
          eventEdit: result,
        });
        this.openModalUpdateDeletetRepas();
      }
    } else {
      this.setState({
        arg: arg,
        isOpenAjout: true,
      });
    }
  };
  handleEventClick = (info) => {
    let arg = info.event._instance.range;
    if (!_.isEmpty(this.state.calendarEvents)) {
      let result = {};
      this.state.calendarEvents.forEach((element) => {
        if (
          moment(arg.start).format("yyyy-MM-DD") ===
          moment(element.start).format("yyyy-MM-DD")
        ) {
          result = Object.assign({}, element, result, {
            [element.title]: element.description,
          });
        }
      });
      if (_.isEmpty(result)) {
        this.setState({
          isOpenAjout: true,
          arg: arg,
        });
      } else {
        this.setState({
          eventEdit: result,
          arg: arg,
        });
        this.openModalUpdateDeletetRepas();
      }
    } else {
      this.setState({
        arg: arg,
        isOpenAjout: true,
        arg: arg,
      });
    }
  };
  myChangeHandlerPetits = (event) => {
    this.setState({ textMenuPetits: event.target.value });
  };
  myChangeHandlerGrands = (event) => {
    this.setState({ textMenuGrands: event.target.value });
  };
  openModalAjoutRepas() {
    this.setState({ isOpenAjout: true });
  }
  closeModalAjoutRepas() {
    this.setState({ isOpenAjout: false });
  }
  openModalUpdateDeletetRepas() {
    this.setState({ isOpenDeleteUpdate: true });
  }
  closeModalUpdateDeletetRepas() {
    this.setState({ isOpenDeleteUpdate: false });
  }
  handleSubmitRepas = (textrepsPetit, textrepsGrands) => {
    this.setState({
      calendarEvents: this.state.calendarEvents.concat(
        {
          title: "Menu des petits",
          start: this.state.arg.date,
        },
        {
          title: "Menu des grands",
          start: this.state.arg.date,
        }
      ),
      textMenuPetits: textrepsPetit,
      textMenuGrands: textrepsGrands,
      isOpenAjout: false,
    });

    let dataRepas = {
      date: this.state.arg.dateStr,
      menuDesGrands: textrepsGrands,
      menuDesPetits: textrepsPetit,
    };
    this.props.addMenusRepas(localStorage.getItem("token"), dataRepas, this.getMonthDateRange(this.state.activeStart));
  };
  handleModifieRepas = (textrepsPetit, textrepsGrands) => {
    let dataRepas = {
      menuDesGrands: textrepsGrands,
      menuDesPetits: textrepsPetit,
    };
    this.props.editMenusRepas(
      localStorage.getItem("token"),
      this.state.eventEdit.id,
      dataRepas,
      this.getMonthDateRange(this.state.activeStart)
    );
    this.setState({ isOpenDeleteUpdate: false });
  };
  handleRepasDelete(event) {
    this.props.deleteMenusRepas(
      localStorage.getItem("token"),
      this.state.eventEdit.id,
      this.getMonthDateRange(this.state.activeStart)
    );
    this.setState({ isOpenDeleteUpdate: false });
  }

  render() {
    return (
      <div className="main-wrapper staff">
        <div className="banner p-0 d-flex align-items-center justify-content-center">
          <Link to="/" className="back-link">
            Retour
          </Link>
          <div className="content">
            <h1>
              Planning des repas
              <br /> <small>Les petits plats de la crèche</small>
            </h1>
          </div>
        </div>

        <div
          className="content p-0"
          style={!this.props.loading ? { display: "none" } : {}}
        >
          <DotLoader
            size={100}
            color={"#ff7d26"}
            css={override}
            loading={this.props.loading}
          />
        </div>
        <div
          className="content-planning"
          style={this.props.loading ? { display: "none" } : {}}
        >
          <FullCalendar
            displayEventTime="false"
            defaultView="dayGridMonth"
            locale="fr"
            style={"font-size: 0em;"}
            header={{
              left: "prev",
              center: "title",
              right: "next",
            }}
            plugins={[dayGridPlugin, timeGridPlugin, interactionPlugin]}
            ref={this.calendarComponentRef}
            events={this.state.calendarEvents}
            dateClick={this.handleDateClick}
            eventClick={this.handleEventClick}
            viewSkeletonRender={(info) => {
              this.callbackFunction(info);
            }}
          />
        </div>
        {this.state.isOpenAjout ? (
          <ModalAjoutMenus
            handleSubmitRepas={this.handleSubmitRepas}
            handleDateClick={this.handleDateClick}
            closeModalAjoutRepas={this.closeModalAjoutRepas}
            dateRepas={this.state.arg}
          />
        ) : (
          ""
        )}
        {this.state.isOpenDeleteUpdate ? (
          <ModalUpdateDeleteMenus
            closeModalUpdateDeletetRepas={this.closeModalUpdateDeletetRepas}
            handleModifieRepas={this.handleModifieRepas}
            handleRepasDelete={this.handleRepasDelete}
            eventEdit={this.state.eventEdit}
          />
        ) : (
          ""
        )}
      </div>
    );
  }
}
const mapStateToProps = (state) => ({
  dataRepas: state.Menus.data,
  loading: state.Menus.loading,
});

export default connect(mapStateToProps, {
  getMenusRepas,
  addMenusRepas,
  editMenusRepas,
  deleteMenusRepas,
})(Menus);
